function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M13.642 3.133c1.167 0 1.98 1.066 2.046 2.3l.004.163v.537H19c.552 0 1 .448 1 1 0 .513-.386.936-.883.994L19 8.133h-.541l-.72 11.58c-.025 1.2-.956 2.174-2.155 2.278L15.42 22H8.561c-1.203-.024-2.185-.946-2.289-2.088L5.54 8.133H5c-.552 0-1-.447-1-1 0-.513.386-.935.883-.993L5 6.133h3.307v-.537c0-1.248.766-2.366 1.9-2.457l.15-.006h3.285zm2.813 5H7.544l.717 11.54c.003.152.112.281.25.317l.07.01H15.4c.164-.003.298-.115.332-.29l.008-.079.715-11.498zm-2.889-3h-3.133l-.005.012c-.057.078-.1.199-.115.34l-.005.11-.001.538h3.385v-.537c0-.152-.032-.287-.08-.385l-.046-.078z"
});

var SvgDelete = function SvgDelete(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDelete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete.ba64144c.svg";
export { ForwardRef as ReactComponent };